export const byteLength = Buffer.byteLength;
